export default __webpack_public_path__ + "static/media/sunflowers_puresky_1k.7abadcbb.hdr";